module.exports = __webpack_public_path__ + "img/t.0ed02862.jpg";